/* eslint-disable */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { detectBrowserLanguage } from '@/components/shared/languageCodes';

const en_US = require('./languages/en_US.json')
const vi_VN = require('./languages/vi_VN.json')
const tr_TR = require('./languages/tr_TR.json')
const ru_RU = require('./languages/ru_RU.json')
const ro_RO = require('./languages/ro_RO.json')
const pt_PT = require('./languages/pt_PT.json')
const pl_PL = require('./languages/pl_PL.json')
const ja_JP = require('./languages/ja_JP.json')
const ko_KO = require('./languages/ko_KO.json')
const it_IT = require('./languages/it_IT.json')
const id_ID = require('./languages/id_ID.json')
const hu_HU = require('./languages/hu_HU.json')
const hi_IN = require('./languages/hi_IN.json')
const fr_FR = require('./languages/fr_FR.json')
const es_ES = require('./languages/es_ES.json')
const de_DE = require('./languages/de_DE.json')
const ar_AE = require('./languages/ar_AE.json')
const zh_ZH = require('./languages/zh_ZH.json')

const domainLanguageCode = detectBrowserLanguage();

Vue.use(VueI18n);

const locale = domainLanguageCode;
const messages = {
  en_US,
  vi_VN,
  tr_TR,
  ru_RU,
  ro_RO,
  pt_PT,
  pl_PL,
  ja_JP,
  ko_KO,
  it_IT,
  id_ID,
  hu_HU,
  hi_IN,
  fr_FR,
  es_ES,
  de_DE,
  ar_AE,
  zh_ZH
};

const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'en_US',
});

export default i18n;
